import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { STORE_LINKS, ASSETS } from "../../data/landing";
import { useLanguage } from "../../i18n/LanguageContext";

export const MobileStickyCTA = () => {
  const { t } = useLanguage();
  const s = t.sticky;
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 md:hidden"
          data-testid="mobile-sticky-cta"
        >
          <div className="mx-3 mb-3 flex items-center justify-between gap-3 rounded-2xl border border-[#7B1113]/10 bg-[#FCFAF7]/90 p-2.5 pl-3 shadow-[0_-8px_30px_-12px_rgba(123,17,19,0.25)] backdrop-blur-xl">
            <div className="flex items-center gap-2.5 min-w-0">
              <img
                src={ASSETS.logo}
                alt={t.brand}
                loading="lazy"
                className="h-9 w-9 shrink-0 rounded-full object-cover"
              />
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-[#2A1112]">
                  {s.name}
                </p>
                <p className="truncate text-xs text-[#5E4646]">{s.tagline}</p>
              </div>
            </div>
            <a
              href={STORE_LINKS.googlePlay}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-sticky-download-btn"
              className="shrink-0 rounded-full bg-[#7B1113] px-4 py-2.5 text-sm font-semibold text-[#FCFAF7] shadow-[0_10px_22px_-10px_rgba(123,17,19,0.6)]"
            >
              {s.downloadApp}
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileStickyCTA;
